import { fork } from 'redux-saga/effects'
import { watchUsers } from './UserSagas';
import { watchAuth } from './AuthSagas';
import { watchOt } from './OtSagas';
import { watchCustomer } from './CustomerSagas';
import { watchChangelog } from './ChangelogSagas';
import { watchEntity } from './EntitySagas';
import { watchProduct } from './ProductSagas';
import { watchReport } from './ReportSagas';
import { watchUnit } from './UnitSagas';
import API from '../Services/Api'

const api = API.create(process.env.REACT_APP_API_URL);

export default function * root () {
    yield fork(watchUsers, api);
    yield fork(watchAuth, api);
    yield fork(watchOt, api);
    yield fork(watchCustomer, api);
    yield fork(watchChangelog, api);
    yield fork(watchEntity, api);
    yield fork(watchProduct, api);
    yield fork(watchReport, api);
    yield fork(watchUnit, api);
}



// WEBPACK FOOTER //
// ./src/Sagas/index.js